export const cellActionStyles = { width: 100, padding: '0 16px' };
